<template>
  <div class="btf-switch" @click="selectedToggle" :class="{disabled: disabled}" :disabled="disabled">
    <div class="b-base">
        <i class="icon size-20" :class="[iconClass[0]]"></i>
        <i class="icon size-20" :class="[iconClass[1]]"></i>
    </div>
    <div class="b-button" :class="{on: setType === modeType[1]}">
        <div class="button-wrap active">
            <i class="icon size-20" :class="[`${iconClass[0]}`]"></i>
            <i class="icon size-20" :class="[`${iconClass[1]}`]"></i>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TypeSelector',
  props: {
    iconClass: {
      type: Array,
      default: () => { return [] }
    },
    modeType: {
      type: Array,
      default: () => { return [] }
    },
    initSelect: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selectedType: false
    }
  },
  computed: {
    setType () {
      const mode = this.selectedType ? this.modeType[0] : this.modeType[1]
      return mode
    }
  },
  mounted () {
    this.selectedType = this.modeType[0] === this.value
  },
  methods: {
    selectedToggle () {
      this.selectedType = !this.selectedType
      const mode = this.selectedType ? this.modeType[0] : this.modeType[1]
      this.$emit('select', mode)
    }
  }

}
</script>

<style lang="scss">
.btf-switch {
    cursor: pointer;
    width: 90px;
    height: 32px;
    border-radius: 16px;
    outline: 1px solid #D7D7D7;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    margin: 1px;
    .b-base {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.1);
        box-shadow: 0px 1px 1px 1px rgba(0, 0, 0, 0.04) inset 0 0 1px;
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        padding: 6px 15px;
        box-sizing: border-box;
    }
    .button-wrap {
        width: 90px;
        padding: 6px 15px;
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        background-color: #fff;
        transition: transform 200ms;
        //opacity: 0.4;
        box-sizing: border-box;
    }
    .b-button {
        position: absolute;
        z-index: 10;
        width: 50px;
        height: 32px;
        top: 0;
        left: 0;
        border-radius: 16px;
        box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.20);
        overflow: hidden;
        transition: all 200ms;
        &.on {
            transform: translateX(40px);
            .button-wrap {
                transform: translateX(-40px);
            }
        }
    }
    &:disabled,
    &.disabled {
      opacity: .5;
      pointer-events: none;
      filter: grayscale(1);
    }
}

</style>
